<eo-file-upload-base [label]="label" [help]="help" [errors]="errors">
  <div class="flex gap-1">
    <p-button
      *ngIf="files.length > 0"
      type="button"
      [icon]="cancelIcon"
      [label]="cancelLabel"
      [styleClass]="cancelStyleClass"
      [disabled]="loading"
      (onClick)="onFileRemove()"
    />
    <p-fileUpload
      *ngIf="files.length === 0"
      name="files{{ id }}[]"
      mode="basic"
      [showUploadButton]="false"
      [files]="files"
      [styleClass]="styleClass"
      [chooseLabel]="chooseLabel"
      [chooseIcon]="chooseIcon"
      [multiple]="multiple"
      [accept]="accept"
      [maxFileSize]="maxFileSize"
      [fileLimit]="fileLimit"
      (onSelect)="onFilesSelect($event)"
    />
    <input
      class="w-full {{ inputStyleClass }}"
      type="text"
      pInputText
      disabled
      tooltipPosition="top"
      [value]="getFilenamesString()"
      [pTooltip]="inputTooltip"
    />
    <ng-template #inputTooltip>
      <div >
        <ul class="w-full ui-tooltip-text" style="width: 1000px;">
          <li *ngFor="let fileName of getFilenamesArray()">{{ fileName }}</li>
        </ul>
      </div>
    </ng-template>

    <a
      pButton
      *ngIf="showDownloadFile()"
      icon="pi pi-download"
      pTooltip="Λήψη αρχείου"
      class="p-button-outlined p-button-success p-2 px-3"
      [href]="formControl.value[0]?.FileUrl"
      target="_blank"
    ></a>
  </div>
</eo-file-upload-base>
